import { createFileRoute } from "@tanstack/react-router";
import HelpView from "@/components/views/HelpView";

export const Route = createFileRoute("/help")({
  component: HelpView,
});
